export default __webpack_public_path__ + "static/media/pagination-orange__active.db69270b.svg";